<template>
  <div v-if="mainConfig.streambidStreamingSubdomain" class="ta-auction-view-cover">
    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        class="embed-responsive-item"
        :src="streamUrl"
        allowfullscreen
        loading="lazy">
      </iframe>
    </div>
  </div>
</template>

<script>
import auctionViewMixin from "@/mixins/auctionViewMixin";

export default {
  name: "AuctionStreambidLiveStream",
  mixins: [auctionViewMixin],
  computed: {
    streamUrl() {
      return `https://${this.mainConfig.streambidStreamingSubdomain}.stream.bid/goclick?auctionID=${this.auction.uuid}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.ta-auction-view-cover {
  margin-bottom: 1rem;

  img {
    height: 300px;
    width: 100%;
    object-fit: cover;
  }
}
</style>
